import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, Toaster } from '@elva/ui';
import { queryClient } from '@/lib/queryClient';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultThemeId="neue" persist storageKey="elva-theme-frontdesk">
        <Toaster position="bottom-right">{children}</Toaster>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
